export const SITES = {
  de: {
    code: 'de',
    path: '/de',
    defaultLocale: 'de',
    localized: {
      academy: false,
      helpCenter: true,
    },
  },
  dach: {
    code: 'dach',
    path: '/dach',
    defaultLocale: 'de',
    localized: {
      academy: false,
      helpCenter: true,
    },
  },
  dk: {
    code: 'dk',
    path: '/dk',
    defaultLocale: 'da',
    localized: {
      academy: false,
      helpCenter: false,
    },
  },
  fi: {
    code: 'fi',
    path: '/fi',
    defaultLocale: 'fi',
    localized: {
      academy: false,
      helpCenter: false,
    },
  },
  no: {
    code: 'no',
    path: '/no',
    defaultLocale: 'no',
    localized: {
      academy: false,
      helpCenter: false,
    },
  },
  se: {
    code: 'se',
    path: '/se',
    defaultLocale: 'sv',
    localized: {
      academy: true,
      helpCenter: true,
    },
  },
  uk: {
    code: 'uk',
    path: '/uk',
    defaultLocale: 'en',
    localized: {
      academy: true,
      helpCenter: true,
    },
  },
  us: {
    code: 'us',
    path: '/us',
    defaultLocale: 'en',
    localized: {
      academy: true,
      helpCenter: true,
    },
  },
  com: {
    code: 'com',
    path: '',
    defaultLocale: 'en',
    localized: {
      academy: true,
      helpCenter: true,
    },
  },
};

export const STATES = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  PENDING: 'PENDING',
  LOADING: 'LOADING',
  REQUEST: 'REQUEST',
};
